export default __webpack_public_path__ + "static/media/Steel Knuckles.a0c9af57.png";